import { useCallback, useEffect, useMemo, useState } from "react"
import { fetchCurrency, updateDecoderPacks } from "../../service/subscribers/subscribersApi";
import { createRegionRegex } from "../utils/createRegionRegex";
import ModalMessage from "../components/ModalMessage";

const DecoderInfo = ({ region, id, decoders, domain, fetchAgain }) => {
    const [isClicked, setIsClicked] = useState([]);
    const [modal, setModal] = useState(false);
    const [currency, setCurrency] = useState("CFA");

    const regionRegex = useMemo(() => createRegionRegex(region), [region]);

    const getCurrency = useCallback(async (signal) => {
        const currencyCode = await fetchCurrency(signal);
        setCurrency(currencyCode);
    }, []);

    const postDecoderChanges = useCallback(async (payload) => {
        try {
            await updateDecoderPacks(payload);
            await fetchAgain?.();
            setModal(true);
        } catch (error) {
            console.error(error);
        }
    }, [fetchAgain]);

    const toggleChoose = useCallback((value, decoderIndex, packIndex) => {
        setIsClicked((prev) => {
            const next = [...(prev || [])];
            const row = [...(next[decoderIndex] || [])];
            row[packIndex] = value;
            next[decoderIndex] = row;
            return next;
        });
    }, []);

    const deactivateAll = useCallback((decoderIndex) => {
        setIsClicked((prev) => {
            const next = [...(prev || [])];
            const row = next[decoderIndex] || [];
            next[decoderIndex] = row.map(() => false);
            return next;
        });
    }, []);

    const handleSubmit = useCallback((decoderIndex) => {
        const decoder = decoders?.[decoderIndex];
        const filteredPacks = decoder?.packs?.filter((pack) => regionRegex.test(pack?.name || "")) || [];

        const selectedPackIds = filteredPacks.reduce((acc, pack, packIndex) => {
            if (isClicked?.[decoderIndex]?.[packIndex]) acc.push(pack.pack_id);
            return acc;
        }, []);

        postDecoderChanges({
            user_id: id,
            decoder_id: decoder?.decoder_id,
            packs: selectedPackIds,
        });
    }, [decoders, id, isClicked, postDecoderChanges, regionRegex]);

    // Build checkbox state aligned with the filtered packs (same filter as UI & submit).
    useEffect(() => {
        if (!decoders) return;

        const nextClicked = decoders.map((decoder) => {
            const filteredPacks = decoder?.packs?.filter((pack) => regionRegex.test(pack?.name || "")) || [];
            return filteredPacks.map((pack) => (!!pack?.expire && !pack?.one_time));
        });

        setIsClicked(nextClicked);
    }, [decoders, regionRegex]);

    // Fetch currency once per mount/domain (not on every decoders/region update).
    useEffect(() => {
        const controller = new AbortController();
        getCurrency(controller.signal);
        return () => controller.abort();
    }, [getCurrency]);

    return  <>
    
    {modal && (
      <ModalMessage
        title="Success!"
        message="Changes applied succsessfully"
        actions={<button className="error-btn" onClick={() => setModal(false)}>Close</button>}
      />
    )}

      <div className="packets-list-block">
                     {decoders && decoders?.map((decoder, index) => {
                         const filteredPacks = decoder?.packs?.filter((pack) => regionRegex.test(pack?.name || "")) || [];
                         return (
                         <div className="packets-list-card" key={index}>
                             <div className="packets-list-card-header">
                                 <div>Decoder ID: <span className="pointed">{decoder.decoder_id}</span></div>
                                 <div><button className="packets-list-apply" onClick={() => handleSubmit(index)}>Apply</button></div> 
                             </div>
                             <table style={{maxWidth: '100%', minWidth: '100%'}}>
                                 <thead><tr style={{textAlign:'center'}}><td colSpan={4}>Packages:</td></tr></thead>
                                 <tbody>
                                    {filteredPacks.map((pack, ind) =>  (
                                       <tr key={ind}>
                                           <td className="td-btn"><input style={{ boxShadow: '1px 1px 1px 1px #00000080' }} type="checkbox" 
                                           checked={!!(isClicked && isClicked[index] && isClicked[index][ind])}
                                           onChange={(e) => toggleChoose(e.target.checked, index, ind)}/></td>
                                           <td>{pack?.name}</td>
                                           <td>{currency} <span className="pointed">{pack?.cost || 0}</span> per 30 days </td>
                                           <td>{pack.one_time ? "Date of expiration:" :  "Date of next activation:"} <span className="pointed">{pack?.expire || "Inactive"}</span></td>
                                       </tr>   
                                   ))}
                                 </tbody>
                                 <tfoot><tr className="clickable" style={{textAlign:'center'}} onClick={() => deactivateAll(index)}><td colSpan={4}>Deactivate all packages</td></tr></tfoot> 
                             </table>
                         </div>
                         );
                     })
                     }
                </div> 
    </>
}

export default DecoderInfo